var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-sm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4008 3.76687C12.1453 3.65508 11.8547 3.65508 11.5992 3.76687L5.59918 6.39187C5.23519 6.55112 5 6.91073 5 7.30803V13C5 14.7136 5.61571 16.2833 6.63795 17.5001C7.92137 15.9724 9.84647 15 11.9999 15C14.1534 15 16.0785 15.9724 17.3619 17.5002C18.3843 16.2834 19 14.7136 19 13V7.30803C19 6.91073 18.7648 6.55112 18.4008 6.39187L12.4008 3.76687ZM15.8701 18.8338C14.9525 17.7135 13.5589 17 11.9999 17C10.441 17 9.04741 17.7135 8.12979 18.8337C9.23837 19.5706 10.569 20 12 20C13.4309 20 14.7615 19.5707 15.8701 18.8338ZM10.7975 1.93456C11.5641 1.59919 12.4359 1.59919 13.2025 1.93456L19.2025 4.55956C20.2944 5.03729 21 6.11614 21 7.30803V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V7.30803C3 6.11614 3.70558 5.03729 4.79754 4.55956L10.7975 1.93456ZM12 8.5C11.0335 8.5 10.25 9.2835 10.25 10.25C10.25 11.2165 11.0335 12 12 12C12.9665 12 13.75 11.2165 13.75 10.25C13.75 9.2835 12.9665 8.5 12 8.5ZM8.25 10.25C8.25 8.17893 9.92893 6.5 12 6.5C14.0711 6.5 15.75 8.17893 15.75 10.25C15.75 12.3211 14.0711 14 12 14C9.92893 14 8.25 12.3211 8.25 10.25Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.73ca0df3633d47bfca385f1784d79ab2.svg";
export { ForwardRef as ReactComponent };